<template>
  <div id="home" :style="loadingStyle" class="home">
    <span class="infoWrapper">
      <span class="info" >
        <p class="infoText">
          GW2 Notifier is a simple service that sends you push notifications whenever you have buy
          or sell orders fulfilled on the Black Lion Trading Post.
        </p>
      </span>
    </span>
    <span id="apiKey">
      <v-text-field
        @input="updateApiKey"
        label="API Key"
        placeholder="XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXXXXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX"
        outlined
        background-color="white"
        messages="placeholder"
      >
        <template v-slot:message="{ message }">
          <span id="message">
            Use an <a href="https://account.arena.net/applications" target="_blank">api key</a> to subscribe this device and configure settings
          </span>
        </template>
      </v-text-field>
    </span>
    <br>
    <ul>
      <li>
        Only the <i>tradingpost</i> permission is required, but future updates may
        utilize the <i>inventories</i>, <i>characters</i>, and <i>wallet</i> permission as well.
      </li>
      <li> To update settings, re-enter your api key at any time. </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'home',
  mounted() {
    this.clearState();
  },
  computed: {
    ...mapGetters([
      'apiKeySet',
    ]),
    ...mapState(['loading']),
    loadingStyle() {
      if (this.loading) return { display: 'none' };
      return {};
    },
  },
  methods: {
    ...mapMutations(['setApiKey', 'clearState']),
    updateApiKey(value) {
      if (value.length !== 72) return;
      this.setApiKey(value);
    },
  },
  watch: {
    apiKeySet: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.$router.push('/settings');
        }
      },
    },
  },
};
</script>

<style>
#apiKey {
  display: inline-block;
  font-size: 0.95rem;
  height: 2.5rem;
  width: 90%;
  max-width: 40rem;
  text-align: center;
}

#message {
  font-size: 0.8rem;
}

.infoWrapper {
  display: block;
  width: 100%;
}

.info {
  display: inline-flex;
  max-width: 40rem;
  text-align: center;
}

ul {
  color: #2c3e50b3;
  margin-top: 4rem;
  max-width: 35rem;
  display: inline-block;
  text-align: left;
  font-size: .95rem;
}

.infoText {
  margin-top: 0.2rem;
}

.aboutHeader {
  margin-bottom: 0px;
  margin-top: 4rem;
}

#home {
  width: 100%;
}

.white {
  background-color: whitesmoke !important;
}
</style>
